import { CompetenceBaseEx } from "@/server/backend-api";
import { EciuImage } from "@/components/EciuImage";
import { mcn } from "@/utils";
import { IconActionClose } from "@/components/Icons";
import { IconThumbsUp } from "../Icons/IconThumbsUp";
import { MotivationScanLike } from "@/utils/motivationScan";

export interface TopicCardProps {
  classNames?: string;
  competence: CompetenceBaseEx;
  likeOrDislike?: MotivationScanLike;
  onLikeClicked?: () => void;
  onDislikeClicked?: () => void;
}

export function TopicCard(props: TopicCardProps) {
  const {
    competence,
    classNames,
    likeOrDislike,
    onLikeClicked,
    onDislikeClicked,
  } = props;

  // Prioritize short description over subtitle.
  const cardText = competence.shortDescription ?? competence.subTitle;
  return (
    <div className={mcn("", "bg-blue rounded-3 p-md relative", classNames)}>
      {likeOrDislike !== undefined && (
        <div
          className={mcn(
            "absolute right-0 top-8 z-50 text-black rounded-l-1",
            likeOrDislike === MotivationScanLike.Like && "bg-light-green",
            likeOrDislike === MotivationScanLike.Dislike && "bg-white"
          )}
        >
          <span
            className={
              "text-style-caption px-xs py-2xs flex flex-row items-center"
            }
          >
            <span className="flex items-center space-x-md gap-2xs text-center">
              {likeOrDislike === MotivationScanLike.Like && (
                <>
                  <IconThumbsUp className="w-sm h-sm mr-2xs" />I like it
                </>
              )}
              {likeOrDislike === MotivationScanLike.Dislike && (
                <>
                  <IconActionClose className="w-md h-md" />
                  Not for me
                </>
              )}
            </span>
          </span>
        </div>
      )}
      <div className="h-[180px]">
        <EciuImage
          priority
          className="w-[280px] h-[280px]"
          src={competence.imageUri}
          rounded="3"
        />
      </div>
      <div className="min-h-[230px]">
        <h3 className={"text-style-headline5 mt-md"}>{competence.name}</h3>
        <p className={"text-style-body2 mt-md max-h-[180px] line-clamp-[9]"}>
          {cardText}
        </p>
      </div>

      <div className={"mt-md grid grid-cols-2 space-x-md justify-between"}>
        <button
          className={mcn(
            "h-12 rounded-3 text-grey-160 bg-white font-bold flex items-center justify-center space-x-3xs",
            "focus-visible:default-focus",
            "hover:opacity-80"
          )}
          onClick={onDislikeClicked}
        >
          <IconActionClose className="w-lg h-lg" />
          <span>NOT FOR ME</span>
        </button>
        <button
          className={mcn(
            "h-12 rounded-3 text-black bg-green-100 font-bold flex items-center justify-center space-x-xs",
            "focus-visible:default-focus",
            "hover:opacity-80"
          )}
          onClick={onLikeClicked}
        >
          <IconThumbsUp className="w-lg h-lg" />
          <span>I LIKE IT</span>
        </button>
      </div>
    </div>
  );
}
